import { Container, ContainerPadding, DisplayTag } from '@volkswagen-onehub/components-core';
import { default as React } from 'react';
import styled from 'styled-components';
import { Promocion } from '../../services/ofertas-service/models/ofertas';

const ClickableLabel = styled.div`
	cursor: pointer;
`;

export const OfertaPromotionLabel = ({
	promociones,
	handleLayerOnClick,
	setSelectedPromotion,
}: {
	promociones: Promocion[];
	handleLayerOnClick: () => void;
	setSelectedPromotion: React.Dispatch<React.SetStateAction<Promocion | undefined>>;
}): React.ReactElement => {
	const checkNumberPromotions = (promociones: Promocion[]): Promocion[] => {
		if (promociones.length < 2) {
			return promociones;
		}

		if (window.innerWidth < 560) {
			return promociones.slice(0, 1);
		}

		return promociones.slice(0, 2);
	};

	const checkedPromotions = checkNumberPromotions(promociones);

	const handleOnClick = (selectedPromotion: Promocion) => {
		if (!selectedPromotion.descripcion) {
			return;
		}

		handleLayerOnClick();
		setSelectedPromotion(selectedPromotion);
	};

	return (
		<Container
			data-testid="oferta-promotion-label"
			padding={{ bottom: ContainerPadding.static150 }}
			horizontalAlign={'flex-start'}
		>
			{checkedPromotions.map((checkedPromotion, index) => (
				<ClickableLabel key={index} onClick={() => handleOnClick(checkedPromotion)}>
					<DisplayTag
						className="oferta-promotion-label"
						appearance={index === 0 ? 'new' : 'info'}
						text={checkedPromotion.text}
					/>
				</ClickableLabel>
			))}
		</Container>
	);
};
